export default "__VITE_ASSET__C1qDdT_s__"